export default "__VITE_ASSET__nNRo_XqG__"